export const GLOBAL_AUDIT_SEARCH_ERR =
  '(User ID/Job ID or User Name) OR (Table Name and Field Name) OR (Key Type and Key Value) is required.';
export const GLOBAL_DATE_INVALID =
  'Please enter date in the correct format.Example MM/DD/CCYY Example MM-DD-CCYY Example MMDDCCYY.';
export const EVENT_GT_DT_ERROR =
  'End Date must be greater than or equal to begin date.';
export const BEGIN_TIME_INVALID = 'Begin Time format is invalid.';
export const END_TIME_INVALID = 'End Time format is invalid.';
export const NO_RECORDS_WITHSEARCH =
  'No records found for the search criteria entered.';